import { Formatters } from '@leverege/ui-attributes';
const defaultNumberFormatOptions = {
  type: 'attr.formatter.number',
  localize: true,
  maxDecimals: 2
};
const defaultCurrencyFormatOptions = {
  type: 'attr.formatter.number',
  localize: true,
  maxDecimals: 2,
  prefix: '$'
};
const defaultPercentFormatOptions = {
  type: 'attr.formatter.number',
  maxDecimals: 2,
  suffix: '%'
};
const defaultTimestampFormatOptions = {
  type: 'attr.formatter.timestamp',
  format: 'Pp'
};
function formatNumber(value, options) {
  return Formatters.format(value, {
    ...defaultNumberFormatOptions,
    ...options
  }).join('');
}
function formatCurrency(value, options) {
  return Formatters.format(value, {
    ...defaultCurrencyFormatOptions,
    ...options
  }).join('');
}
function formatPercent(value, options) {
  return Formatters.format(value, {
    ...defaultPercentFormatOptions,
    ...options
  }).join('');
}
function formatTimestamp(value, options) {
  return Formatters.format(value, {
    ...defaultTimestampFormatOptions,
    ...options
  }).join('');
}
export { formatNumber, formatCurrency, formatPercent, formatTimestamp };